import { Fragment, type ReactNode } from 'react';
import { parseServerContent } from '../../../components/composer/mentionUtils';
import { MentionChip } from './MentionChip';

// Walk parsed tokens into React children. Text segments keep their
// whitespace (the surrounding <Text> uses `whitespace-pre-wrap`), mention
// tokens become atomic chips.
export const renderTokens = (content: string): ReactNode => {
  const tokens = parseServerContent(content);
  if (tokens.length === 0) return content;
  return tokens.map((token, idx) => {
    if (token.type === 'text') {
      return <Fragment key={idx}>{token.text}</Fragment>;
    }
    return (
      <MentionChip
        key={idx}
        name={token.mention.name}
        entity={token.mention.entity}
      />
    );
  });
};
